import React from "react";
import TradingViewWidget, { Themes } from "react-tradingview-widget";

import useSize from "../../../../Utils/useSize/useSize";

export default function Chart() {
  const windowSize = useSize();

  return (
    <div style={{ height: windowSize[1] - 100, width: windowSize[0] }}>
      <TradingViewWidget
        symbol="NASDAQ:AAPL"
        theme={Themes.LIGHT}
        locale="en"
        autosize
      />
    </div>
  );
}
